import MasterCrudPage from "@/components/MasterCrudPage";

export default function EscalationRules() {
  return (
    <MasterCrudPage
      endpoint="/masters/escalation-rules"
      title="Escalation Rules"
      breadcrumbs={["Masters", "Escalations"]}
      testIdPrefix="escalation"
      initialForm={{ is_active: true, delay_threshold_hours: 24, escalate_to_manager: true, whatsapp_reminder_frequency_hours: 6 }}
      columns={[
        { key: "code", label: "Code" },
        { key: "name", label: "Name" },
        { key: "delay_threshold_hours", label: "Threshold (hrs)" },
        { key: "escalate_to_manager", label: "Manager", render: r => r.escalate_to_manager ? "Yes" : "No" },
        { key: "escalate_to_department_head", label: "Dept. Head", render: r => r.escalate_to_department_head ? "Yes" : "No" },
      ]}
      formFields={[
        { key: "code", label: "Code", required: true },
        { key: "name", label: "Name", required: true },
        { key: "delay_threshold_hours", label: "Delay Threshold (hours)", type: "number" },
        { key: "whatsapp_reminder_frequency_hours", label: "WhatsApp Reminder Frequency (hours)", type: "number" },
        { key: "escalate_to_manager", label: "Escalate to Manager", type: "checkbox" },
        { key: "escalate_to_department_head", label: "Escalate to Department Head", type: "checkbox" },
        { key: "escalate_to_admin", label: "Escalate to Admin", type: "checkbox" },
        { key: "is_active", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
